import React from 'react'
import Mushrooms from '../components/Mushrooms'

const Home = () => {
  return (
   <Mushrooms></Mushrooms>
  )
}

export default Home